import { Link, Text } from 'vvs-uikit'
import { useTranslation } from 'contexts/Localization'

export const FarmGuide = () => {
  const { t } = useTranslation()

  return (
    <>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 1')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t(
          'Click on the button below to go to the Crystal Farms page. Alternatively, you can go straight to the page on your own',
        )}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 2')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('Stake your LP token in the corresponding farm')}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('Step 3')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('If the above transaction is successful, you will earn EXP')}
      </Text>
      <Text mb="8px" color="black" fontWeight="600">
        {t('NOTE')}
      </Text>
      <Text mb="32px" color="darkGrey">
        {t('You will need to hold LP tokens to complete this quest. If you do not have any, check out this ')}
        <Link
          inline
          underline="always"
          bold
          href="https://docs.vvs.finance/product-guides/bling-swap/provide-liquidity"
          target="_blank"
        >
          {t('guide')}
        </Link>
        {t(' on how to obtain them')}
      </Text>
    </>
  )
}
